import Loader from '@tcl-boron-prefabs/loader';
import classnames from 'classnames';
import React from 'react';

import useSpinnerStyles from './Spinner.styles';

export interface SpinnerProps {
  loading?: boolean;
  className?: string;
  centered?: boolean;
  transparent?: boolean;
  relativePosition?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({
  className,
  loading = false,
  centered = false,
  transparent = false,
  relativePosition = false,
}) => {
  const classes = useSpinnerStyles();

  if (!loading) {
    return null;
  }

  return (
    <div
      className={classnames(
        className,
        classes.loadingContainer,
        { [classes.centered]: centered },
        { [classes.transparent]: transparent },
        { [classes.relativePosition]: relativePosition },
      )}
    >
      <div className={classes.loading}>
        <Loader scale={2} />
      </div>
    </div>
  );
};
